module.exports = __webpack_public_path__ + "static/calc-d9ca649ce9eaf79e63811be4b433d91a.png";